define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/config",
	"csi/def/Action",
	"csi/def/Relationship",
	"csi/def/ViewRef",
	"csi/store/Names",
	"csi/store/_base",
	"csi/xml",
	"csi/xml/Query"
], function(declare, lang, config, Action, Relationship, ViewRef, Names, csiStore, xml, Query) {

	return declare(null, {
		_buildField: function(ctx, field, tr, tdControl) {
			var control = this.inherited(arguments);

			if (field.m_id == "BOMProductColors") {
				if (this.isCopy()) {
					const prompt = config.getSubtypeSetting(this.defView.getSourceNode().Subtype, "PromptBOMColors") || false;
					this.setFieldHidden(field, !prompt || this.defView.getSource().getAction().getId() === "PromoteStyleBOMToThemeBOM");
				} else {
					this.setFieldHidden(field, true);
				}
			}

			return control;
		},

		_hasActiveProductBOMSubtype: function() {
			// summary: return true if there is any Active BOMSubtype BOMSubtypeSettings
			return config.hasSubtype(this.defView.getRootClass().type);
		},

		onChangeBOMSubtype: function(defView, field, value) {
			const prompt = config.getSubtypeSetting(value, "PromptBOMColors") || false;
			const colorField = defView.getField("BOMProductColors");
			if (colorField) {
				this.setFieldHidden(colorField, !prompt);
			}
		},

		getFieldStore: function(field, value) {
			if (field.getControlName() == "BOMProductColors") {
				const q = new Query().Attr("Active", xml.OP_EQUALS, true);

				const rel = lang.mixin(new Relationship(), {
					m_id: "ProductColors",
					m_url: this.defView.getSource().m_urlParent,
					m_query: q
				});

				const storeOptions = csiStore.namesOptionsByRelationship(this.getContext(), rel);

				storeOptions.action = lang.mixin(new Action(), {
					m_viewRef: lang.mixin(new ViewRef(), {
						m_id: "ProductColors",
						m_url: this.defView.getSource().m_urlParent
					}),
					m_fixedQuery: q
				});
				return new Names(storeOptions);
			} else {
				return this.inherited(arguments);
			}
		}
	});
})
